import {
  EarthquakeResistanceStandard,
  Office,
  Structure,
  Transportation,
} from '~/models/types'

export const officeStationsToStationTextList = (
  stations: Office['stations'],
): string[] =>
  stations
    .reduce<
      {
        transportationLines: string[]
        stationName: string
        transportationAndTime: string
      }[]
    >(
      (
        acc,
        { transportation, time, transportationLine, transportationName, name },
      ) => {
        const transportationAndTime =
          transportationToJaText(transportation) + time + '分'

        const existingElementIndex = acc.findIndex(
          (element) =>
            element.stationName === name &&
            element.transportationAndTime === transportationAndTime,
        )

        if (existingElementIndex === -1) {
          acc.push({
            transportationLines: [
              transportationName || transportationLine.name,
            ],
            stationName: name,
            transportationAndTime,
          })
        } else {
          acc[existingElementIndex].transportationLines.push(
            transportationLine.name,
          )
        }

        return acc
      },
      [],
    )
    .map(
      ({ transportationLines, stationName, transportationAndTime }) =>
        `${stationName}駅（${transportationLines.join('・')}）  ${transportationAndTime}`,
    )

export const officeOtherAccessesToOtherAccessTextList = (
  otherAccesses: Office['otherAccesses'],
): string[] =>
  (otherAccesses ?? []).map(
    ({ accessType, description }) =>
      `（${accessType === 'BUS' ? 'バス' : 'その他'}） ${description || ''} `,
  )

export const officeSpacesToFacilityTextList = (
  spaces: Office['spaces'],
): string[] =>
  spaces
    .flatMap(({ facilities }) => facilities)
    .sort((a, b) => a.id - b.id)
    .map((facility) => facility.name)
    .reduce<string[]>((acc, facilityName) => {
      if (!acc.includes(facilityName)) acc.push(facilityName)
      return acc
    }, [])

const transportationToJaText = (transportation: Transportation) => {
  switch (transportation) {
    case 'WALK':
      return '徒歩'
    case 'BUS':
      return 'バス'
    default:
      return transportation
  }
}

export const earthquakeResistanceStandardToJaText = (
  earthquakeResistanceStandard: EarthquakeResistanceStandard,
) => {
  switch (earthquakeResistanceStandard) {
    case 'NEW_STANDARD':
      return '新耐震'
    case 'OLD_STANDARD':
      return '旧耐震'
    case 'OTHER':
      return 'その他'
    default:
      return earthquakeResistanceStandard
  }
}

export const structureToJaText = (structure: Structure) => {
  switch (structure) {
    case 'WOODEN':
      return '木造'
    case 'STEEL':
      return '鉄骨'
    case 'REINFORCED_CONCRETE':
      return 'RC'
    case 'STEEL_REINFORCED_CONCRETE':
      return 'SRC'
    case 'OTHER':
      return 'その他'
    default:
      return structure
  }
}
